import { FindingDto } from './finding-dto';
import { ScanModule, ScanType, Severity } from '../enums';

export interface HorizonFindingDto extends FindingDto {
  scanModule: ScanModule.Horizon;
}

export namespace HorizonFindingDto {
  export function mapFromApiValue(horizonFindingDto: any): HorizonFindingDto {
    return {
      ...horizonFindingDto,
      scanType: ScanType.mapFromApiValue(horizonFindingDto.scanType),
      scanModule: ScanModule.Horizon,
      severity: Severity.mapFromApiValue(horizonFindingDto.severity),
    };
  }
}
